import { useCallback } from 'react';
import useWeb3 from '../useWeb3';
import { getTrade } from '../../utils/contractHelpers';
import { useRecoilValue } from 'recoil';
import { userSmartAccount } from '../../components/RecoilAtom';
import { convertFromWei } from '../../utils/helpers';

export const DynamicPayout = () => {
    const web3 = useWeb3();
    const smartAccount = useRecoilValue(userSmartAccount)
    const DynamicPayoutHook = useCallback(async (address) => {
        const contract = getTrade(address, web3);
        try {
            const dynamicPayout = await contract.methods.getDynamicPayout(smartAccount).call();
            return dynamicPayout;
        } catch (e) {
            console.error("Transaction error:", e.message || e);
            throw e;
        }
    }, [web3, smartAccount]);

    return { DynamicPayoutHook };
};

export default DynamicPayout;
